import { useMemo } from 'react';
import { Route, Routes, Navigate, useResolvedPath, RouteProps } from 'react-router-dom';

import { EngagementDashboard, EngagementPlan, NoMatch } from '@/pages';
import { NavigationSub } from '@/components';

type RouteConfig = {
	main: React.ComponentType;
} & RouteProps;

export const Engagement = () => {
	const path = useResolvedPath('').pathname;

	const routes: RouteConfig[] = useMemo(
		() => [
			{
				path: '/dashboard',
				main: EngagementDashboard,
			},
			{
				path: '/engagement-plan',
				main: EngagementPlan,
			},
			{
				path: '/*',
				main: NoMatch,
			},
		],
		[]
	);

	return (
		<>
			<NavigationSub
				navigationItems={[
					{
						to: `${path}/dashboard`,
						title: 'Dashboard',
					},
					{
						to: `${path}/engagement-plan`,
						title: 'Engagement Plan',
					},
				]}
			/>

			<Routes>
				<Route index element={<Navigate to="dashboard" replace />} />

				{routes.map((route, index) => {
					return <Route key={index} path={route.path} element={<route.main />} />;
				})}
			</Routes>
		</>
	);
};
